const initState = {
  subtopics: [],
};

const rankingReducer = (state = initState, action) => {
  switch (action.type) {
    case "ADDED_RANKING":
      return {
        ...state,
        addRankingSuccess: {
          message: action.message,
          type: "addRankingSuccess",
          id: action.id,
        },
      };
    case "ADDED_RANKING_ERROR":
      return {
        ...state,
        addRankingError: {
          message: action.err.message,
          type: "addRankingError",
        },
      };

    case "UPDATED_RANKING":
      return {
        ...state,
        updateRankingSuccess: {
          message: action.message,
          type: "updateRankingSuccess",
        },
      };
    case "UPDATED_RANKING_ERROR":
      return {
        ...state,
        updateRankingError: {
          message: action.err.message,
          type: "updateRankingError",
        },
      };

    case "DELETED_RANKING":
      return {
        ...state,
        deleteRankingSuccess: {
          message: action.message,
          type: "deleteRankingSuccess",
        },
      };

    case "DELETED_RANKING_ERROR":
      return {
        ...state,
        deleteRankingError: {
          message: action.err.message,
          type: "deleteRankingError",
        },
      };

    default:
      return state;
  }
};

export default rankingReducer;
